import React, { ReactNode } from 'react';
import { Outlet } from 'react-router';
import { useAppSelector } from 'src/hooks/redux';

export interface ProtectedParams {
    isAdmin: boolean;
    isAuth: boolean;
    isPageCustomerSuccess?: boolean;
    children?: ReactNode;
}

const Protected = ({ isAuth, isAdmin, isPageCustomerSuccess, children }: ProtectedParams): any => {
    const role = useAppSelector((state) => state.User.role_id);
    const rolesAllowedCS = [2, 3]
    const isRoleCustomerSuccess = rolesAllowedCS.includes(role);

    if (!isAuth) {
        const next = window.location.href;
        return (window.location.assign(`/login?next=${next}`));
    }
    if (!isAdmin) {
        return (window.location.assign("/"));
    }
    if (isPageCustomerSuccess) {
        return isRoleCustomerSuccess ? children : window.location.assign("/");
    }
    return children || <Outlet />;
};

export default Protected;
